/**
 * Generato automaticamente.
 * framework-cfg-utenti
 */

export type EnumPersonaGiuridicaDTOTipoPg =
  (typeof EnumPersonaGiuridicaDTOTipoPg)[keyof typeof EnumPersonaGiuridicaDTOTipoPg];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumPersonaGiuridicaDTOTipoPg = {
  PUBBLICA: 'PUBBLICA',
  PRIVATA: 'PRIVATA',
} as const;
